import React from "react";
import styles from "./style.module.css";
import locationIcon from "../../../Assets/locationssIcon.png";
import { useNavigate } from "react-router-dom";
import glass from "../../../Assets/glass.png";
import spoon from "../../../Assets/spoonIcon.png";
import bed from "../../../Assets/bed.png";
import { FaLongArrowAltDown } from "react-icons/fa";
import { AiFillCheckCircle, AiOutlineCheckCircle } from "react-icons/ai";
import { useState } from "react";
const Card = ({ value, arr, index, type }) => {
  const navigate = useNavigate();
  const [check, setCheck] = useState(false);

  return (
    <div
      className={styles.parent}
      style={{
        cursor: "pointer",
      }}
    >
      <section className={styles.child1}>
        <img src={value.eventImg} width="100%" height={"100%"} alt="cardImg" />
      </section>
      <section className={styles.child2}>
        <div className={styles.content}>
          <h6 className={`my-2 m-0`}>Palaza Mayoure</h6>
          <h6 className={`my-2 m-0`}>Madrid</h6>
        </div>
        <div className={styles.content}>
          <p className={`my-2`}>
            <img src={locationIcon} width={20} />
            <span className="text-white mx-2">20 KM</span>
          </p>
        </div>
        {type === "point" && (
          <div className={styles.content}>
            <img src={glass} width={25} />
            <img className="mx-3" src={spoon} width={25} />
            <img src={bed} width={25} />
          </div>
        )}
        <div className={styles.content}></div>
      </section>
    </div>
  );
};

export default Card;
